import { findContact } from './contacts'
import type { AutoPrompt } from '../types/activity'

export const autoPrompts: AutoPrompt[] = [
  {
    id: 'AP-1',
    trigger: 'under-contract',
    title: 'Call the listing agent — new contract',
    contact: findContact('RP-108'),
    context: 'Loan 4482 · Whitaker · went under contract yesterday',
    dueLabel: 'Due today',
    urgency: 'urgent',
    category: 'realtor-outreach',
    script:
      'Introduce yourself as the buyer’s lender, confirm timelines, and offer weekly status updates through closing.',
    linkTo: '/loans',
  },
  {
    id: 'AP-2',
    trigger: 'milestone',
    title: 'Appraisal received — update the partner',
    contact: findContact('A-2201'),
    context: 'Loan 4471 · Serrano · appraisal came in at value',
    dueLabel: 'Due today',
    urgency: 'attention',
    category: 'partner-meeting',
    script:
      'Share the appraisal result, confirm the clear-to-close date, and ask what she needs for her seller.',
    linkTo: '/realtors',
  },
  {
    id: 'AP-3',
    trigger: 'past-client',
    title: 'Quarterly touch overdue',
    contact: findContact('PC-202'),
    context: 'Closed Aug 2022 · last touch 4 months ago',
    dueLabel: 'Overdue 32 days',
    urgency: 'urgent',
    category: 'past-client-call',
    script:
      'Check in on the home, mention likely MI removal eligibility, and offer a mortgage-planning review.',
    linkTo: '/past-clients',
  },
  {
    id: 'AP-4',
    trigger: 'escrow-analysis',
    title: 'Escrow analysis call',
    contact: findContact('PC-206'),
    context: 'Tax reassessment raised their payment $118/mo',
    dueLabel: 'Due this week',
    urgency: 'attention',
    category: 'past-client-call',
    script:
      'Explain the escrow shortage, walk through options, and set expectations for next year’s payment.',
    linkTo: '/past-clients',
  },
  {
    id: 'AP-5',
    trigger: 'recurring-partner',
    title: 'Bi-weekly prospect check-in',
    contact: findContact('RP-103'),
    context: 'Meeting set Thursday · recurring cadence',
    dueLabel: 'Due Thursday',
    urgency: 'normal',
    category: 'partner-meeting',
    script:
      'Confirm Thursday coffee and bring the first-time-buyer program one-pager she asked about.',
    linkTo: '/prospects',
  },
]

export const triggerMeta: Record<
  AutoPrompt['trigger'],
  { label: string; classes: string }
> = {
  'under-contract': {
    label: 'Under contract',
    classes: 'bg-brand-50 text-brand-700 ring-brand-200',
  },
  milestone: {
    label: 'Loan milestone',
    classes: 'bg-teal-50 text-teal-700 ring-teal-200',
  },
  'recurring-partner': {
    label: 'Recurring',
    classes: 'bg-navy-50 text-navy-600 ring-navy-200',
  },
  'past-client': {
    label: 'Past client',
    classes: 'bg-success-50 text-success-700 ring-success-200',
  },
  'escrow-analysis': {
    label: 'Escrow analysis',
    classes: 'bg-warn-50 text-warn-700 ring-warn-200',
  },
}
